import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  errorMessage,
  SubmitQuestion,
} from '@features/applicationQuestions';
import axiosInstance from '@server/axiosInstance';
import { templetePostQuestions } from '../api/constants';
import { templateList } from '../constants';

type usePostTemplateApplicationQuestionProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const usePostTemplateApplicationQuestion = ({
  setErrorText = () => { },
}: usePostTemplateApplicationQuestionProps) => {
  const client = useQueryClient();

  const {
    mutate: postApplicationQuestion,
    isLoading: isPostApplicationQuestionLoading,
  } = useMutation({
    mutationFn: (variables: SubmitQuestion) =>
      axiosInstance
        .post(templetePostQuestions, variables)
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status !== 200) {
        setErrorText(data.message);
      } else {
        setErrorText('');
        client.invalidateQueries([templateList]);
      }
    },
    onError: () => {
      setErrorText(errorMessage);
    },
  });

  return { postApplicationQuestion, isPostApplicationQuestionLoading };
};
